import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actor } from 'app/modules/models/actor.type';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActorService {

  protected apiRoute = environment.RESOURCE_API;

  private currentSupervisorSubject = new BehaviorSubject<Actor | null>(null);
  private _actorUpdatedInformation$ = new BehaviorSubject<Actor | null>(null);

  setCurrentSupervisor(actor: Actor) {
    this.currentSupervisorSubject.next(actor);
  }

  getCurrentSupervisor() {
    return this.currentSupervisorSubject.asObservable();
  }

  set actorUpdatedInformation(value: Actor) {
    this._actorUpdatedInformation$.next(value);
  }

  get actorUpdatedInformation$(): Observable<Actor> {
    return this._actorUpdatedInformation$.asObservable();
  }

  constructor(private _httpClient: HttpClient) { }

  GetActorsByCompanyIdEvenTypeId(companyId: string, eventTypeId: string): Observable<Actor[]> {
    const route = this.apiRoute + environment.apiCatalog.actor.controllerRoute + environment.apiCatalog.actor.subRoutes.getActorsByCompanyIdEvenTypeId + companyId + '/' + eventTypeId;
    return this._httpClient.get<Actor[]>(route, this.prepareHeader());
  }

  GetActorsByCompanyId(companyId: string): Observable<Actor[]> {
    const route = this.apiRoute + environment.apiCatalog.actor.controllerRoute + environment.apiCatalog.actor.subRoutes.getActorsByCompanyId + companyId;
    return this._httpClient.get<Actor[]>(route, this.prepareHeader());
  }

  GetActorsRelatedToCustomer(customerId: string): Observable<Actor[]> {
    const route = this.apiRoute + environment.apiCatalog.actor.controllerRoute + environment.apiCatalog.actor.subRoutes.getActorsRelatedToCustomer + customerId;
    return this._httpClient.get<Actor[]>(route, this.prepareHeader());
  }

  CheckActorOverLap(startDate: string, endDate: string, actorId: string, entity: string,): Observable<any> {
    const route = this.apiRoute + environment.apiCatalog.actor.controllerRoute + environment.apiCatalog.actor.subRoutes.checkActorOverLap + startDate + '/' + endDate + '/' + actorId + '/' + entity;
    return this._httpClient.get<any>(route, this.prepareHeader());
  }

  private prepareHeader(): Object {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    return { headers: headers };
  }
}
